var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal fade show in", attrs: { id: "fellowModal" } },
    [
      _c("div", { staticClass: "modal-dialog modal-lg" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "a",
              {
                staticClass: "close",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.closeModal($event)
                  }
                }
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-8" },
                [
                  _c(
                    "h3",
                    {
                      staticClass: "modal-title",
                      staticStyle: { "margin-bottom": "12px" }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.selectedFellow.FirstName) +
                          " " +
                          _vm._s(_vm.selectedFellow.LastName)
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.selectedFellow.Applications__r
                    ? _c("h6", [
                        _vm._v(
                          _vm._s(
                            _vm.selectedFellow.Applications__r.records[0]
                              .College_Institution__r.Name
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedFellow.Applications__r
                    ? _c("h4", [
                        _c("small", [
                          _vm._v(
                            _vm._s(
                              _vm.selectedFellow.Applications__r.records[0]
                                .Major__c
                            )
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedFellow.Fellow_Years__r &&
                  _vm.selectedFellow.Fellow_Years__r.records.length
                    ? [
                        _c("hr"),
                        _vm._v(" "),
                        _vm._l(_vm.recordsOrderedByYear, function(year) {
                          return _c("article", [
                            _c("h4", [
                              _c("small", [
                                _vm._v(
                                  _vm._s(year.Website_Display_Year__c) +
                                    " Summer Internship"
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("h2", [
                              _vm._v(
                                _vm._s(year.Internship__r.Organization_Name__c)
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(year.Internship__r.Name)),
                              year.Internship__r.International_City__c
                                ? _c("span", [
                                    _vm._v(
                                      ", " +
                                        _vm._s(
                                          year.Internship__r
                                            .International_City__c
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              year.Internship__r.International_Country__c &&
                              year.Internship__r.International_Country__c !=
                                "USA"
                                ? _c("span", [
                                    _vm._v(
                                      ", " +
                                        _vm._s(
                                          year.Internship__r
                                            .International_Country__c
                                        )
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        })
                      ]
                    : [_c("hr"), _vm._v(" "), _vm._m(0)]
                ],
                2
              ),
              _vm._v(" "),
              _vm.fellowPhoto
                ? _c("div", { staticClass: "col-md-4 hidden-sm hidden-xs" }, [
                    _c("div", {
                      staticClass: "img-circle img-tj",
                      domProps: { innerHTML: _vm._s(_vm.fellowPhoto) }
                    })
                  ])
                : _vm._e()
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h4", [_c("small", [_vm._v("Summer Internship")])]),
      _vm._v(" "),
      _c("h6", [_vm._v("Details coming soon")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f676bd6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f676bd6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/jk-modal.vue
// module id = 393
// module chunks = 0